import { offer as EnUsOffer } from '../en-us/offer';
import { AgResourceLanguage } from '../types';

export const offer: AgResourceLanguage['offer'] = {
  ...EnUsOffer,
  offerPrice: {
    firstTimePurchaseIncludes: 'La primera compra incluye:',
    free: 'Gratis',
    total: 'Total',
    valueOfOneTimePurchase: 'Valor de compra única',
    firstMonthFree: 'Consigue un mes gratis de AG1 + un kit de bienvenida gratuito',
    firstMonthFreeTag: 'Primer Mes Gratis'
  }
};
